import Swiper from 'swiper';
import 'swiper/src/swiper.scss';
import projectsSection from 'components/projects-section/init';

export default function (container) {
  container.querySelectorAll('[data-clients-list]').forEach((list) => {
    const section = list.closest('[data-mobile-overflow]');
    const wrapper = list.querySelector('ul');
    const slides = wrapper.querySelectorAll('li');
    const colors = wrapper.querySelectorAll('[data-color]');
    const images = wrapper.querySelectorAll('img');

    projectsSection(list);

    if (!window.isMobile.any) return;

    section.style.overflow = section.dataset.mobileOverflow;
    list.classList.add('swiper-container');
    wrapper.classList.add('swiper-wrapper');
    slides.forEach(slide => slide.classList.add('swiper-slide'));
    images.forEach((img) => {
      img.dataset.src = img.dataset.mobileSrc;
      delete img.dataset.imageLazy;
      delete img.dataset.mobileSrc;
      img.classList.add('swiper-lazy');
    });
    colors.forEach(el => el.style.backgroundColor = el.dataset.color);
    if (list.parentElement.classList.contains('cell')) {
      list.parentElement.setAttribute('class', 'small-12 cell');
    }
    const swiper = new Swiper(list, {
      breakpoints: {
        639: {
          slidesPerView: 3,
        },
        1023: {
          slidesPerView: 4,
        },
        1199: {
          slidesPerView: 5,
        },
      },
      lazy: {
        loadPrevNext: true,
        loadOnTransitionStart: true,
      },
      preloadImages: false,
      slidesPerView: 6,
      spaceBetween: 16,
      speed: 500,
    });
    swiper.prependSlide('<li class="swiper-slide"></li>');
    swiper.appendSlide('<li class="swiper-slide"></li>');
    swiper.slideTo(0, 0);
  });
}
